import React from "react";

export default function KitchenOrderCard({
  order,
  onUpdate,
  updating,
}) {
  const isNew = ["PENDING", "CONFIRMED"].includes(
    order.status
  );

  const isPreparing = order.status === "PREPARING";
  const isReady = order.status === "READY";

  const statusClass = isNew
    ? "new"
    : isPreparing
    ? "preparing"
    : "ready";

  const actionStatus = isNew
    ? "PREPARING"
    : isPreparing
    ? "READY"
    : isReady
    ? "SERVED"
    : null;

  const actionLabel = isNew
    ? "Start Preparing"
    : isPreparing
    ? "Mark Ready"
    : isReady
    ? "Mark Served"
    : "";

  return (
    <article className={`kitchen-order-card ${statusClass}`}>
      <div className="kitchen-order-header">
        <div>
          <h3>#{order.order_number}</h3>
          <p>{order.order_type === "PARCEL" ? "PARCEL / TAKEAWAY" : `Table ${order.table_number || "N/A"}`}</p>
        </div>

        <span className={`kitchen-status-badge ${statusClass}`}>
          {isNew
            ? "NEW"
            : isPreparing
            ? "PREPARING"
            : "READY"}
        </span>
      </div>

      <div className="kitchen-order-meta">
        <span>{order.payment_method || "Unknown"}</span>

        <span>
          {order.created_at
            ? new Date(order.created_at).toLocaleTimeString(
                [],
                {
                  hour: "2-digit",
                  minute: "2-digit",
                }
              )
            : ""}
        </span>
      </div>

      <div className="kitchen-order-items">
        {(order.items || []).map((item) => (
          <div key={item.id} className="kitchen-order-item">
            <strong>{item.quantity} ×</strong>
            <span>{item.item_name}</span>
          </div>
        ))}
      </div>

      {order.notes && (
        <div className="kitchen-order-notes">
          <strong>Special instructions:</strong>
          <p>{order.notes}</p>
        </div>
      )}

      {actionStatus && (
        <button
          type="button"
          className={`kitchen-action-button ${statusClass}`}
          disabled={updating}
          onClick={() => onUpdate(order.id, actionStatus)}
        >
          {updating ? "Updating..." : actionLabel}
        </button>
      )}
    </article>
  );
}